enum DedupeExemptionKeywords {
    MAINTENANCE_MODE = "maintenance mode"
}

export default DedupeExemptionKeywords